export default "__VITE_ASSET__CB$h5VX5__"